// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Fe","articleImagesWrap":"Ge","articleImage":"He","singleImage":"Ie"};